<template>
    <div class="w-full sm:w-96 xl:w-80 2xl:w-96 mx-auto" id="left-sidebar" :class="{ 'hidden': large }">
        <button @click="hideCart" class="hidden lg:flex mr-auto">
            {{ __('Back') }}
            <ArrowLongLeftIcon class="h-6 w-6 inline-block" />
        </button>
        <div class="card bg-base-100">
            <div class="card-body text-center p-5">
                <img :src="user.image || imgProfile" alt="profile" class="w-28 h-28 mx-auto rounded-full">
                <p class="mt-4 text-black">{{ user.phone }}</p>
                <p class="text-lg text-black">{{ user.username ? user.username : user.name }}</p>
                <div class="alert alert-warning p-1 !bg-red-50 !text-red-custom-2 justify-center">
                    <div>
                        <span class="text-xs">
                            <ExclamationTriangleIcon class="w-4 h-4 inline text-red-custom-2" />
                            {{ __('Your invoice will be displayed including temporary orders, and after your order is confirmed, the invoice will be updated.') }}
                        </span>
                    </div>
                </div>
                <div class="flex flex-col gap-2" v-if="user.check_condition" :class="{'opacity-50': !Auth.isUpdated}">
                    <div class="flex justify-between mt-6">
                        <span class="text-red-custom-2 text-sm font-medium">{{ __('account balance check') }}</span>
                        <div>
                            <span class="text-red-custom-2 text-sm font-medium">{{
                                user.liability_check?.toLocaleString()
                            }}</span>
                            <Currency />
                        </div>
                    </div>
                    <div class="divider my-0 h-auto"></div>
                    <div class="flex justify-between">
                        <span class="text-red-custom-2 text-sm font-medium">{{ __('account balance cash') }}</span>
                        <div>
                            <span class="text-red-custom-2 font-medium">{{ user.liability_cash?.toLocaleString('en-US')
                            }}</span>
                            <Currency />
                        </div>
                    </div>
                    <div class="divider my-0 h-auto"></div>
                </div>
                <div class="flex justify-between" :class="{'opacity-50': !Auth.isUpdated}">
                    <span class="text-red-custom-2 text-sm font-medium">{{ __('Total account balance') }}</span>
                    <div>
                        <span class="text-red-custom-2 text-sm font-medium">{{ (user.liability_check +
                            user.liability_cash)?.toLocaleString('en-US')
                        }}</span>
                        <Currency />
                    </div>
                </div>
                <div class="flex flex-col gap-2" v-if="user.check_condition" :class="{'opacity-50': !Auth.isUpdated}">
                    <div class="divider my-0 h-auto"></div>
                    <div class="flex justify-between">
                        <span class="text-green-custom-3 text-sm font-medium">{{ __('Creditor check') }}</span>
                        <div>
                            <span class="text-green-custom-3 text-sm font-medium">{{
                                user.creditor_check?.toLocaleString() }}</span>
                            <Currency />
                        </div>
                    </div>
                    <div class="divider my-0 h-auto"></div>
                    <div class="flex justify-between">
                        <span class="text-green-custom-3 text-sm font-medium">{{ __('Creditor cash') }}</span>
                        <div>
                            <span class="text-green-custom-3 text-sm font-medium">{{ user.creditor_cash?.toLocaleString('en-US')
                            }}</span>
                            <Currency />
                        </div>
                    </div>
                </div>
                <div class="divider my-0 h-auto" :class="{'opacity-50': !Auth.isUpdated}"></div>
                <div class="flex justify-between" :class="{'opacity-50': !Auth.isUpdated}">
                    <span class="text-green-custom-3 text-sm font-medium">{{ __('Creditor of the general account') }}</span>
                    <div>
                        <span class="text-green-custom-3 text-sm font-medium">{{ (user.creditor_check +
                            user.creditor_cash)?.toLocaleString('en-US')
                        }}</span>
                        <Currency />
                    </div>
                </div>

            </div>
        </div>
        <div class="card bg-base-100 collapse collapse-arrow mt-4" v-if="cards.length">
            <input type="checkbox" />
            <div class="collapse-title bg-white text-black">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-5 h-5 inline-block">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
                </svg>
                <span class="mr-1 text-sm">{{ __('Company account numbers for account settlement') }}</span>
            </div>
            <div class="collapse-content bg-base-100 text-black">
                <div v-for="(card, index) in cards">
                    <div class="flex items-center">
                        <img class="w-12 h-12" alt="card" :src="card.logo">
                        <div class="mr-3">
                            <p class="text-sm">{{ __('Credit Cart') + ': ' + card.number }}</p>
                            <p class="text-sm my-0.5">{{ __('Account number') + ': ' + card.account }}</p>
                            <p class="text-sm">{{ __('Shaba number') + ': ' + card.shaba }}</p>
                        </div>
                    </div>
                    <div class="divider my-2 h-auto" v-if="cards.length - 1 != index"></div>
                </div>
            </div>
        </div>
        <div class="card mt-4 bg-base-100">
            <div class="card-body p-5">
                <h6 class="card-title text-sm">{{ __('Cash goods on the invoice') }}</h6>
                <div class="divider my-0 h-auto bg-red-custom-2"></div>
                <p class="mt-4 text-end">
                    <span class="text-red-custom-2 text-lg font-bold">{{ (user.cart?.cash + (user.check_condition ? 0 : user.cart?.check))?.toLocaleString() }}</span>
                    <Currency />
                </p>
            </div>
        </div>
        <div class="card mt-4 bg-base-100" v-if="user.check_condition">
            <div class="card-body p-5">
                <h6 class="card-title text-sm">{{ __('Czech goods on the invoice') }}</h6>
                <div class="divider my-0 h-auto bg-green-custom-3"></div>
                <div class="alert alert-success py-0 !bg-green-custom-2 !text-green-custom-3 justify-center"
                    v-if="user.cart?.check >= user.credit_limit && user.credit_limit_date">
                    <div>
                        <span class="text-xs">{{ __('Your credit limit has expired but you can up date') + ' ' +
                            user.credit_limit_date + + ' ' + __('Register your order') }}</span>
                    </div>
                </div>
                <div class="alert alert-success py-0 !bg-green-custom-2 !text-green-custom-3 justify-center"
                    v-if="user.credit_limit">
                    <div>
                        <span class="text-sm">{{ __('Your check purchase limit') + ' ' +
                            user.credit_limit?.toLocaleString('en-US') + ' ' + __(currency) + ' ' + __('be') }}</span>
                    </div>
                </div>
                <p class="mt-3 text-end">
                    <span class="text-green-custom-3 text-lg font-bold">{{ user.cart?.check?.toLocaleString()
                    }}</span>
                    <Currency />
                </p>
            </div>
        </div>
        <router-link :to="{ name: 'cart' }" class="btn btn-warning btn-block mt-4 text-white" v-if="$route.name !== 'cart'"
            active-class="active">{{ __('Register or edit an invoice') }}</router-link>
        <button class="btn btn-info mt-3 btn-block cursor-default flex justify-between no-animation text-white">
            <span>{{ __('Sum total invoice') }}</span>
            <span class="text-lg">
                {{ user.cart?.total?.toLocaleString() }}
                <Currency />
            </span>
        </button>
    </div>
</template>
<script setup>
import Auth from "../../../composables/shop/auth";
import { computed, inject } from 'vue';
import { ArrowLongLeftIcon,ExclamationTriangleIcon } from '@heroicons/vue/24/outline';
import Currency from '../../svg/Currency.vue';
defineProps(['large']);
const user = Auth.user;
const currency = window.nikran.currency;
const cards = window.nikran.cards;
const isCartBtn = inject('isCartBtn');
isCartBtn.value = true;
const hideCart = () => {
    const sidebar = document.getElementById('left-sidebar');
    sidebar.classList.add('hidden');
    sidebar.previousElementSibling?.classList?.remove('hidden');
    document.getElementById('btn-cart')?.classList?.remove('!hidden');
}
const imgProfile = computed(() => window.APP_URL + '/assets/uploads/profile.png');
</script>